import React from 'react';
import Footer from './Footer'; // Ensure Footer.js is in the same directory

const UmamiDbPage = () => {
  return (
    <>
      <section id="how-to-use" className="how-to-use-section m-3">
        <div className="container">
          <h1 className="text-center mb-5">Umami DB</h1>
          <div className="row">
            <div className="col-xl-12">
              <p>
                Umami DB is a powerful tool designed to help you predict and analyze the umami flavor of various compounds using their SMILES sequences. Here's how you can make the most out of it:
              </p>
              <ol>
                <li>
                  <strong>Enter a SMILES Sequence:</strong> Start by entering the SMILES (Simplified Molecular Input Line Entry System) sequence of the compound you're interested in.
                </li>
                <li>
                  <strong>Submit for Prediction:</strong> Once you've entered the sequence, click the "Predict" button. Umami DB will process the information and provide you with a sweetness prediction for the compound.
                </li>
                <li>
                  <strong>Review Results:</strong> The results will show up on the screen, providing insights into the potential sweetness level of your compound. You can use this information to guide your research or product development.
                </li>
                <li>
                  <strong>Explore Further:</strong> Feel free to experiment with different SMILES sequences to predict various compounds' sweetness levels. The database is continuously updated to provide the most accurate predictions.
                </li>
                <li>
                  <strong>Explore Further:</strong> Feel free to experiment with different SMILES sequences to predict various compounds' sweetness levels. The database is continuously updated to provide the most accurate predictions.
                </li>
                <li>
                  <strong>Explore Further:</strong> Feel free to experiment with different SMILES sequences to predict various compounds' sweetness levels. The database is continuously updated to provide the most accurate predictions.
                </li>
                <li>
                  <strong>Explore Further:</strong> Feel free to experiment with different SMILES sequences to predict various compounds' sweetness levels. The database is continuously updated to provide the most accurate predictions.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default UmamiDbPage;